/* eslint-disable @typescript-eslint/no-unsafe-call */
import { PortalType } from "@studyportals/domain-client";
import { H3Event } from "h3";

export const getPortalType = (): PortalType => {

	if (import.meta.server) {
		const event: H3Event = (typeof useEvent !== 'undefined' ? useEvent() : null) || useRequestEvent();
		if (event) {
			return getPortalTypeFromHostname(event.headers.get('host'));
		}
	} else {
		return getPortalTypeFromHostname(window.location.host);
	}

	return PortalType.DISTANCE_LEARNING;
}


const getPortalTypeFromHostname = (hostname: string | undefined): PortalType => {
	if (!hostname) return PortalType.PHD;

	switch (true) {
	case hostname.includes("mastersportal"):
		return PortalType.MASTER;
	case hostname.includes("bachelorsportal"):
		return PortalType.BACHELOR;
	case hostname.includes("phdportal"):
		return PortalType.PHD;
	case hostname.includes("shortcoursesportal"):
		return PortalType.SHORT;
	case hostname.includes("distancelearningportal"):
		return PortalType.DISTANCE_LEARNING;
	default:
		return PortalType.PHD;
	}
}